import { render, staticRenderFns } from "./SidebarChildren.vue?vue&type=template&id=d2ea74ce"
import script from "./SidebarChildren.vue?vue&type=script&lang=js"
export * from "./SidebarChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports